import { useEffect, useState } from 'react';

import type { ThemeGroup } from '..';

const useActiveTheme = (themes: ThemeGroup[]) => {
  const [activeThemeId, setActiveThemeId] = useState<number | null>(null);

  useEffect(() => {
    if (activeThemeId === null && themes[0] !== undefined) {
      setActiveThemeId(themes[0].themeId);
    }
  }, [themes, activeThemeId]);

  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    themes.forEach(({ themeId }) => {
      const el = document.getElementById(`theme-${themeId}`);
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry?.isIntersecting) {
            setActiveThemeId(themeId);
          }
        },
        {
          rootMargin: '0% 0% -80% 0%',
          threshold: 0.2,
        },
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [themes]);

  return activeThemeId;
};

export default useActiveTheme;
